import { ExcelForecastTemplateGenerationResponse } from '@futrli-sdk/predict';

import { generateDriverTemplate } from '../../predict/src/core/api/driver';
import { ForecastTemplateGenerationPayload, generateForecastTemplate } from '../../predict/src/core/api/forecast';
import { createMutation } from '../utils/mutations';

type GenerateDriverTemplateResult = Awaited<ReturnType<typeof generateDriverTemplate>>;

export const generateDriverTemplateMutation = (workspaceId: string, organisationId: string) => {
  return createMutation<void, GenerateDriverTemplateResult>({
    mutationFn: () => generateDriverTemplate(workspaceId, organisationId)
  });
};

export const generateForecastTemplateMutation = (workspaceId: string, organisationId: string) => {
  return createMutation<ForecastTemplateGenerationPayload, ExcelForecastTemplateGenerationResponse>({
    mutationFn: data => generateForecastTemplate(workspaceId, organisationId, data)
  });
};
